import * as Sentry from '@sentry/angular';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {__APP_VERSION, environment} from './environments/environment';

Sentry.init({
    dsn: 'https://e2528f0c7249f56a3e04cd96118f1d3f@o281892.ingest.us.sentry.io/4509043278938112',
    release: `arkhe-kiwi-ui@${__APP_VERSION}`,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
